import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { MenuItem } from 'react-bootstrap';
import Dropdown from 'components/Dropdown';
import { change } from 'redux-form';
import { connect } from 'react-redux';

class ItemRelationField extends Component {
  render() {
    const { formValues, disabled } = this.props;
    return (
      <Dropdown disabled={disabled}>
        <Dropdown.Toggle
          title={formValues && formValues.relation}
        ></Dropdown.Toggle>
        <Dropdown.Menu>
          <MenuItem
            eventKey="1"
            onSelect={e => {
              this._handleChangeRelation(e);
            }}
          >
            AND
          </MenuItem>
          <MenuItem
            eventKey="2"
            onSelect={e => {
              this._handleChangeRelation(e);
            }}
          >
            OR
          </MenuItem>
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  _handleChangeRelation = e => {
    const { formName, fieldName } = this.props;
    let relation;
    switch (e) {
      case '1':
        relation = 'AND';
        break;
      case '2':
        relation = 'OR';
        break;
    }
    this.props.dispatch(change(formName, fieldName, relation));
  };
}

ItemRelationField.propTypes = {
  formValues: PropTypes.object,
  formName: PropTypes.string,
  fieldName: PropTypes.string,
};

export default connect()(ItemRelationField);
